/**
 * 线上环境
 */
export const ONLINEHOST = 'https://zjzk.emof.cn/index.php'
// export const ONLINEHOST = 'http://192.168.2.123:8010'

/**
 * 测试环境
 */
// export const QAHOST = 'https://zjzk.emof.cn/index.php'
export const QAHOST = 'http://192.168.1.23:8186/index.php'


export const baseURL = process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST

// 文件地址
export const filePath = 'http://qiniu.bjyl.org.cn/' // 七牛云上传拼接
export const urlStr = process.env.NODE_ENV === 'production' ? 'https://zjzk.emof.cn' : 'http://192.168.1.23:8186'     // 服务器上传拼接
// export const urlStr =  'http://192.168.1.23:8186'    // 服务器上传拼接


//文件地址
export const IMAGE_PATH = baseURL.replace('index.php','')

//客服电话
export const service_phone = '400-999-6541'

// 文件上传地址
// export const fileUpUrl = baseURL + '/api/index/uploadfile' // 服务器上传
export const fileUpUrl = baseURL + '/api/common/upload'

/*
* CKEditor编辑器配置
* */
export const ckEditConfig = () => {
    return {

    }
}


/*
* 缓存字段
* */
export const localAnStore = [
    // {
    //     key: 'user',
    //     type: 'sessionStorage'
    // },
    {
        key: 'user',
        type: 'localStorage'
    },
    {
        key: 'emofUserTokenSafer',
        type: 'cookie',
        day: 365,
        path: '/',
    },
    {
        key: 'cookie_user',
        type: 'cookie',
        day: 365,
        path: '/',
    },

]
